import { House, IdentificationCard, PencilSimple, Images, MagnifyingGlass, Heart, SignOut } from "@phosphor-icons/react";

export const menuItems = (props) => {
    return [
      {
        name: 'Home',
        id: 'my_account',
        step: 'my_account',
        icon: House,
        onClick: ()=> {
          props.setStep('my_account');
        },
      },
      {
        name: 'Profile',
        id: 'profile',
        step: 'profile',
        icon: IdentificationCard,
        onClick: ()=> {
          props.setStep('profile');
        },
      },
      {
        name: 'Edit Profile',
        id: 'editProfile',
        step: 'editProfile',
        icon: PencilSimple,
        onClick: ()=> {
          props.setStep('editProfile');
        },
      },
      {
        name: 'Photos',
        id: 'photos',
        step: 'photos',
        icon: Images,
        onClick: ()=> {
          props.setStep('photos');
        },
      },
      {
        name: 'Search',
        id: 'search',
        step: 'search',
        icon: MagnifyingGlass,
        onClick: ()=> {
          props.setStep('search');
        },
      },
      {
        name: 'Profile Interests',
        id: 'profileInterest',
        step: 'interests',
        icon: Heart,
        onClick: ()=> {
          props.setStep('interests');
        },
      },
      {
        name: 'Logout',
        id: 'logout',
        icon: SignOut,
        onClick: props.signOut,
      }
    ];
  };
